export default __webpack_public_path__ + "static/media/vector-illustration.a5c92495.svg";